import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ropSignupDetails: {},
  ropOTPDetails: {},
  ropEmailDetails: {},
  isLoading: false,
  error: "",
  hasData: false,
  codeStatus: "pending",
  ropStatus: {
    status: false,
    message: ""
  },
  ropEmailStatus: {
    status: false,
    message: ""
  }
};
const ropSignupSlice = createSlice({
  name: "ropSignup",
  initialState,
  reducers: {
    getRopSignUpDataPending: (state, action) => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    getRopSignUpSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.ropSignupDetails = action.payload;
      // if (state.ropSignupDetails.code === "I110") {
      state.ropStatus.message = "Member Added";
      state.ropStatus.status = true;
      sessionStorage.setItem("memberId", state.ropSignupDetails.memberId);
      // }

      state.codeStatus = "success";
    },
    getRopSignupFailure: (state, action) => {
      state.isLoading = false;
      state.codeStatus = "failure";
      state.ropSignupDetails = action.payload.response.data;
      if (state.ropSignupDetails.code === "I850") {
        state.ropStatus.message = "Duplicate";
        state.ropStatus.status = false;
      } else if (state.ropSignupDetails.code === "40100006") {
        state.ropStatus.message = "Valid Guardian Details Mandatory";
        state.ropStatus.status = false;
      } else if (state.ropSignupDetails.code === "40000001") {
        state.ropStatus.message = "The entered city or state is invalid";
        state.ropStatus.status = false;
      } else {
        state.ropStatus.message = "Something went wrong";
        state.ropStatus.status = false;
      }
    },
    updateSignInState: (state, action) => {
      const {
        updatedState
      } = action.payload;
      state.isSignin = updatedState;
    },
    getRopOTPPending: (state, action) => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    getRopOTPSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.ropOTPDetails = action.payload;
      if (state.ropOTPDetails.code === "I110") {
        state.ropStatus.message = "Member Added";
        state.ropStatus.status = true;
        sessionStorage.setItem("memberId", state.ropSignupDetails.memberId);
      }
      state.codeStatus = "success";
    },
    getRopOTPFailure: (state, action) => {
      state.isLoading = false;
      state.codeStatus = "failure";
      state.ropOTPDetails = action.payload.response.data;
      if (state.ropOTPDetails.code === "I850") {
        state.ropStatus.message = "Duplicate";
        state.ropStatus.status = false;
      } else {
        state.ropStatus.message = "Something went wrong";
        state.ropStatus.status = false;
      }
      state.ropStatus.status = false;
    },
    getRopEmmailPending: (state, action) => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    getRopEmmailSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.ropEmailDetails = action.payload;
      if (action?.payload?.code === "I110") {
        state.ropStatus.message = "Member Added";
        state.ropStatus.status = true;
        sessionStorage.setItem("memberId", action?.payload?.memberId);
        sessionStorage.setItem("memberName", action?.payload?.name);
      }
      // if (state.ropEmailDetails.code === "I110") {
      //   state.ropEmailStatus.message = "Account Activated Successfully";
      //   state.ropEmailStatus.status = true;
      //   sessionStorage.setItem("memberId", state.ropSignupDetails.memberId);
      // }
      state.codeStatus = "success";
    },
    getRopEmmailFailure: (state, action) => {
      state.isLoading = false;
      state.codeStatus = "failure";
      state.ropEmailDetails = action.payload.response.data;
      state.ropEmailStatus.status = false;
    },
    getRopOTPReset: state => {
      state.codeStatus = "";
      state.ropSignupDetails = {};
      state.ropOTPDetails = {};
      state.isLoading = false;
      state.error = "";
      state.hasData = false;
      state.ropStatus = {
        status: false,
        message: ""
      };
    }
  }
});
export const {
  getRopSignUpDataPending,
  getRopSignupFailure,
  getRopSignUpSuccess,
  updateSignInState,
  getRopOTPPending,
  getRopOTPSuccess,
  getRopOTPFailure,
  getRopEmmailPending,
  getRopEmmailSuccess,
  getRopEmmailFailure,
  getRopOTPReset
} = ropSignupSlice.actions;
export default ropSignupSlice.reducer;